export { DMS_MODULE } from '../constants';
export const CRUMB_LABEL_KEY = 'Audatex';
export const NAME = 'Audatex';
